// @flow

import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import { translate } from "react-i18next";
import ReactSVG from 'react-svg'
import styled from 'styled-components';
import _ from 'lodash';
import {
    loadVideosDetails,
    setSelectedVideoIndex,
    deleteVideo,
    clearError,
} from '../../../../actions/video';
import {
    setDroneLocation,
    centerMap
} from '../../../../actions/map';
import DefaultButton from '../../../../components/DefaultButton';
import VideoIcon from './../../../../icons/video.svg';
import NextIcon from './../../../../icons/next.svg';
import PrevIcon from './../../../../icons/prev.svg';
import messageManager from './../../../../utilities/messageManager';
import { AXIOS_INSTANCE } from '../../../../types/auth';
import {
    VIDEOS,
    SELECTED_VIDEO_INDEX,
    ERROR,
} from '../../../../types/video';
import type { VideoMetaData, VideoProps } from '../../../../types/video';

const StyledVideoWrapper = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  height: calc(100% - 3px);
  width: 100%;
  flex-direction: column;
  background-color: #242424;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.75);
`;

const StyledIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: #242424;
  color: #ffffff;
`;

const StyledIcon = styled.img`
  height: 30px;
  color: white;
  font-family: Open Sans, sans-serif;
  text-align: center;
  letter-spacing: .5px;
  vertical-align: middle;
  user-select: none;
  display: inline-block;
  text-transform: uppercase;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

const StyledVideo = styled.video`
  height: 99%;
  width: 99.5%;
`;

class VideoWrapper extends React.Component {
    videoPlayer: any;

    constructor() {
        super();
        this.state = {
            menuVisible: false,
        }
    }

    componentDidMount() {
        const { chosenFlight, setSelectedVideoIndex, selectedVideoIndex, setDroneLocation } = this.props;
        if (chosenFlight && chosenFlight.id) {
            setSelectedVideoIndex(selectedVideoIndex ? selectedVideoIndex : 0);
            setDroneLocation(null);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { t, clearError } = this.props;
        if (nextProps.videoRelatedError.text !== "") {
            clearError();
            const translatedMessage = {
                text: t(nextProps.videoRelatedError.text),
                type: nextProps.videoRelatedError.type
            };
            messageManager.show(translatedMessage);         
        }
    }

    selectVideo(next: boolean): void {
        const { setDroneLocation, selectedVideoIndex, setSelectedVideoIndex, videos }: VideoProps = this.props;
        const { length }: Array<VideoMetaData> = videos;

        if (selectedVideoIndex !== null) {
            const index: number = next
            ? (selectedVideoIndex === length - 1 ? 0 : selectedVideoIndex + 1)
            : (selectedVideoIndex === 0 ? length - 1 : selectedVideoIndex - 1);
            setSelectedVideoIndex(index);
            setDroneLocation(null);
        }
    }

    updateDronePosition(videoCurrentTime) {
        const { videos, selectedVideoIndex, videoTrack, setDroneLocation } = this.props;
        if (!videoTrack) return;
        const point = videoTrack.find(p =>
            new Date(p.dateTime).getTime() > (new Date(videos[selectedVideoIndex].beginDateTime).getTime() + videoCurrentTime * 1000)
        );
        if (!point) return;

        setDroneLocation(point);
    }

    componentDidUpdate(prevProps, prevState): void {
        const {
            loadVideosDetails,
            axiosInstance,
            chosenFlight,
            videos,
            setDroneLocation,
            setSelectedVideoIndex,
            selectedVideoIndex
        } = this.props;

        if (!_.isEqual(prevProps.chosenFlight, chosenFlight)) {
            setSelectedVideoIndex(0);
            loadVideosDetails(axiosInstance, chosenFlight ? chosenFlight.id : null);
        }

        if (!_.isEqual(prevProps.videos, videos) || prevProps.selectedVideoIndex !== selectedVideoIndex) {
            const selectedVideoIdx = videos.length === 0 ? null : selectedVideoIndex ? selectedVideoIndex : 0;
            setSelectedVideoIndex(selectedVideoIdx);
            setDroneLocation(null);
        }
    }

    componentWillUnmount(): void {
        const { setDroneLocation, setSelectedVideoIndex } = this.props;
        setSelectedVideoIndex(null);
        setDroneLocation(null);
    }

    render(): React.Node {
        const { BASE_URL, videos, selectedVideoIndex, chosenFlight, isLivePlayerVisible, t } = this.props;
        const selectedIndex = selectedVideoIndex !== null ? selectedVideoIndex : 0;

        if (isLivePlayerVisible === true) {
            return (
                <StyledVideoWrapper>
                    <StyledVideo innerRef={(node) => { this.videoPlayer = node }} controls />
                </StyledVideoWrapper>
            );
        }

        if (!chosenFlight) {
            return (
                <StyledIconWrapper>
                    <ReactSVG
                        path={VideoIcon}
                        style={{
                            fill: '#ffffff',
                            width: '50px',
                            height: '50px'
                        }}
                    />
                    <p>
                        {t('No mission selected please select')}
                    </p>
                </StyledIconWrapper>
            );
        }
        if (videos.length === 0) {
            return (
                <StyledIconWrapper>
                    <ReactSVG
                        path={VideoIcon}
                        style={{
                            fill: '#ffffff',
                            width: '50px',
                            height: '50px'
                        }}
                    />
                    <p>
                        {t('No videos for chosen mission')}
                    </p>
                </StyledIconWrapper>
            );
        }

        const video = videos[selectedIndex];
        const { id, fileName } = video;
        //TODO: pomyslec jak ladnie to zrobic zamiast pobierac z local storage ktore jest nie eleganckie
        const token = localStorage.getItem('token');
        const src: string = `${BASE_URL}videos/${id}/play/${fileName}?token=${token}`;
        return (
            <StyledVideoWrapper
                onClick={(e) => {
                    this.setState({ menuVisible: false })
                    e.stopPropagation();
                }}>
                <DefaultButton
                    style={{ position: 'absolute', zIndex: '10', }}
                    left="5px"
                    top="45%"
                    title={t('Previous video')}
                    onClick={() => {
                        this.selectVideo(false);
                    }}>
                    <StyledIcon src={PrevIcon} />
                </DefaultButton>
                <DefaultButton
                    style={{ position: 'absolute', zIndex: '10', }}
                    right="5px"
                    top="45%"
                    title={t('Next video')}
                    onClick={() => {
                        this.selectVideo(true);
                    }}>
                    <StyledIcon src={NextIcon} />
                </DefaultButton>
                <StyledVideo
                    src={src}
                    innerRef={(node) => { this.videoPlayer = node }}
                    autoPlay
                    muted
                    controls
                    controlsList="nodownload"
                    onTimeUpdate={
                        () => this.updateDronePosition(this.videoPlayer.currentTime)
                    }>
                </StyledVideo>
            </StyledVideoWrapper>
        );
    }
};

const mapStateToProps = state => ({
    [VIDEOS]: state.video.get(VIDEOS),
    [SELECTED_VIDEO_INDEX]: state.video.get(SELECTED_VIDEO_INDEX),
    [ERROR]: state.video.get(ERROR),
    [AXIOS_INSTANCE]: state.auth.get(AXIOS_INSTANCE),
    chosenFlight: state.flightManager.get('chosenFlight'),
    videoTrack: state.video.get('videoTrack'),
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    loadVideosDetails,
    setSelectedVideoIndex,
    deleteVideo,
    clearError,
    setDroneLocation,
    centerMap
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(VideoWrapper));


// WEBPACK FOOTER //
// ./src/containers/content/grid/videoWrapper/VideoWrapper.jsx